import { Button } from "@mui/material"
import PhoneInput from "react-phone-input-2"
import { useDispatch } from "react-redux"
import { openDeleteSavedReceiverPopup, openUpdatingSavedReceiverPopup } from "./savedReceiversSlice"
import { useTranslation } from "react-i18next"

const SavedReceiverItem = ({receiver}) => {
    const {t} = useTranslation()
    const dispatch = useDispatch()
    const handleEditButtonClick = () => {
        dispatch(openUpdatingSavedReceiverPopup(receiver.id))
    }
    const handleDeleteButtonClick = () => {
        dispatch(openDeleteSavedReceiverPopup(receiver.id))
    }
  return (
    <div className=" max-w-sm gap-6 grid grid-cols-12 p-2 border-2 xs:border-3 rounded-lg border-emerald-600">
            <div className="col-span-7 flex flex-col text-left">
                    <span className="font-medium text-xs">{receiver.name}</span>
                        <PhoneInput 
                            disabled={true}
                            value={receiver["phone-number"]}
                            inputClass={`font-normal text-xs`}
                            specialLabel=""
                            className="col-span-10 xs:col-span-8"
                        />
            </div>
            <div className="col-span-5">
                
                <Button
                    variant="contained"
                    sx={{
                        color: "white",
                        bgcolor: "#059669",
                        fontSize: "0.5rem",
                        padding: "0.2rem 1rem",
                        width: "90%",
                        ":hover": {
                            bgcolor: "#047857",
                        },
                    }}
                    onClick={handleEditButtonClick}
                >{t("saved_receivers.edit_button")}</Button>

                <Button
                    variant="contained"
                    sx={{
                        color: "white",
                        bgcolor: "#dc2626",
                        fontSize: "0.5rem",
                        padding: "0.2rem 1rem",
                        width: "90%",
                        ":hover": {
                            bgcolor: "#b91c1c",
                        },
                    }}
                    onClick={handleDeleteButtonClick}
                >{t("saved_receivers.delete_button")}</Button>
            </div>
    </div>
  )
}

export default SavedReceiverItem